<app-loader *ngIf="loading"></app-loader>
<div class="row mb-3">
    <div class="col-12 col-lg-6">
        <app-dynamic-breadcrumb [bgColor]="'transparent'" [fontSize]="'14px'"
            [lastLinkColor]="'rgba(196, 196, 205, 0.42)'" [fontColor]="'#c4c4cd'"></app-dynamic-breadcrumb>
    </div>
</div>
<div class="col-12">
    <div class="row header">Masking Report Pack</div>
</div>
<app-report-pack-filter [(selectedReportPacks)]="selectedReportPack" [showOnlyValidReportPacks]="true"
    [selectedRpIds]="reportPackId" [updateServiceOnRpSelection]="false"
    (selectedReportPacksChange)="onReportPackSelectionChange()">
</app-report-pack-filter>

<app-no-report-pack *ngIf="!selectedReportPack"></app-no-report-pack>

<div class="row mt-3" *ngIf="selectedReportPack">
    <div class="col-12">
        <div>
            <button class="btn btn-modal-pos small-font hvr-shrink float-right" type="button"
                (click)="downloadMaskReportPack()" [disabled]="(reportPackId === null || reportPackId == 0)">
                <span>Download Mask File</span>
            </button>
        </div>
    </div>
</div>
<!-- <div class="row">
    <div class="col-12">
        <div class="row header">Mask Report Pack Selection</div>
        <form #queryEngineForm="ngForm">
            <div class="row form-row">

                <div class="col-1"><label>Report Pack</label></div>
                <div class="col-4">
                    <app-report-pack-filter [(selectedReportPacks)]="selectedReportPack"
                        [showOnlyValidReportPacks]="true" [selectedRpIds]="queryModel.reportPackId"
                        [updateServiceOnRpSelection]="false" (selectedReportPacksChange)="onReportPackSelection()">
                    </app-report-pack-filter>
                </div>
                <div class="col-1"></div>
                <div class="col-2 align-items-center">
                   
                </div>
            </div>
        </form>
    </div>
</div> -->